import { get, startsWith } from 'lodash';
var siteprefixDefault = function (href) { return href; };
var getPublicConfig = get(window, 'skeletonPwa.container.getPublicConfig', function () { return ({}); });
export var siteprefix = (get(window, 'skeletonPwa.container') || {
    siteprefix: siteprefixDefault,
}).siteprefix;
var siteHost = window.location.protocol +
    '//' +
    window.location.hostname +
    (window.location.port ? ':' + window.location.port : '');
export var getFullHref = function (href) {
    return startsWith(href, 'http') || startsWith(href, 'www')
        ? href
        : siteHost + siteprefix(href);
};
export var getConfig = function (configPath, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    return get(get(window, 'datashop.app.config', function () { return ({}); })(), configPath, defaultValue);
};
export var getPatientConfig = function (configPath, defaultValue) {
    if (defaultValue === void 0) { defaultValue = null; }
    return get(getPublicConfig('patient'), configPath, defaultValue);
};
//# sourceMappingURL=index.js.map